import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import {
  AsyncValidatorFn,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RolesManagementStore } from '../../../roles-management/store/roles-management.store';
import { IRole } from '../../../roles-management/interfaces';
import { TranslatePipe } from '../../../../shared/pipes/translationPipe';
import { AsyncPipe } from '@angular/common';

export interface CreateUserForm {
  email: FormControl<string>;
  userRole: FormControl<IRole | null>;
}
export type CustomForm = FormGroup<CreateUserForm>;

@Component({
  selector: 'app-confirm-dialog',
  imports: [
    CommonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    TranslatePipe,
    AsyncPipe,
  ],
  templateUrl: './add-user-dialog.component.html',
  styleUrls: ['./add-user-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddUserDialogComponent {
  readonly dialogRef = inject(MatDialogRef);
  readonly data = inject<{
    description: string;
    customValidator: AsyncValidatorFn;
  }>(MAT_DIALOG_DATA);
  private readonly fb = inject(FormBuilder);
  readonly rolesStore = inject(RolesManagementStore);

  form: CustomForm = this.fb.group({
    email: this.fb.control<string>('', {
      nonNullable: true,
      validators: [Validators.required, Validators.email],
      asyncValidators: [this.data.customValidator],
    }),
    userRole: this.fb.control<IRole | null>(null, {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });
}
